import { formatAudioDuration } from '../utils/localAudio.js';

/**
 * 编辑弹窗内单音频预览播放。
 * 使用方需提供：
 * - computed `previewAudioUrl`
 * - template 中 `ref="previewAudioEl"` 的 audio
 * - 可选 computed `previewAudioFallbackDuration`（秒）
 */
export default {
	data() {
		return {
			previewIsPlaying: false,
			previewCurrentTime: 0,
			previewDuration: 0,
		};
	},
	computed: {
		previewProgressPercent() {
			if (!this.previewDuration) return 0;
			return Math.min(100, (this.previewCurrentTime / this.previewDuration) * 100);
		},
		previewCurrentTimeText() {
			return formatAudioDuration(this.previewCurrentTime);
		},
		previewDurationText() {
			if (this.previewDuration) {
				return formatAudioDuration(this.previewDuration);
			}
			const fallback = Number(this.previewAudioFallbackDuration) || 0;
			return fallback ? formatAudioDuration(fallback) : '00:00';
		},
		canPreviewPlay() {
			return Boolean(this.previewAudioUrl);
		},
	},
	watch: {
		previewAudioUrl() {
			this.resetPreviewPlayer();
		},
	},
	mounted() {
		this.previewDuration = Number(this.previewAudioFallbackDuration) || 0;
	},
	beforeUnmount() {
		this.pausePreviewAudio();
	},
	methods: {
		resetPreviewPlayer() {
			this.pausePreviewAudio();
			this.previewCurrentTime = 0;
			this.previewDuration = Number(this.previewAudioFallbackDuration) || 0;
		},
		onPreviewLoadedMetadata() {
			const audio = this.$refs.previewAudioEl;
			if (audio && Number.isFinite(audio.duration)) {
				this.previewDuration = Math.floor(audio.duration);
			}
		},
		onPreviewTimeUpdate() {
			const audio = this.$refs.previewAudioEl;
			if (audio) {
				this.previewCurrentTime = audio.currentTime || 0;
			}
		},
		onPreviewPlay() {
			this.previewIsPlaying = true;
		},
		onPreviewPause() {
			this.previewIsPlaying = false;
		},
		onPreviewEnded() {
			this.previewIsPlaying = false;
			this.previewCurrentTime = 0;
			const audio = this.$refs.previewAudioEl;
			if (audio) {
				audio.currentTime = 0;
			}
		},
		togglePreviewPlay() {
			if (!this.canPreviewPlay) return;
			const audio = this.$refs.previewAudioEl;
			if (!audio) return;
			if (this.previewIsPlaying) {
				audio.pause();
			} else {
				audio.play().catch(() => {});
			}
		},
		pausePreviewAudio() {
			const audio = this.$refs.previewAudioEl;
			if (audio) {
				audio.pause();
			}
			this.previewIsPlaying = false;
		},
		onPreviewSeek(e) {
			if (!this.canPreviewPlay || !this.previewDuration) return;
			const track = this.$refs.previewProgressTrack;
			const audio = this.$refs.previewAudioEl;
			if (!track || !audio) return;
			const rect = track.getBoundingClientRect();
			const ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
			audio.currentTime = ratio * this.previewDuration;
			this.previewCurrentTime = audio.currentTime;
		},
	},
};
